
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 12.8006C5 13.6591 6.01042 14.1185 6.65733 13.5542L12.1387 8.77308C12.5947 8.37538 12.5958 7.66705 12.1411 7.26793L6.65967 2.45662C6.01342 1.88937 5 2.34828 5 3.20818V12.8006Z","fill":"#10001F"}})])
          )
        }
      }
    